<template>
  <div class="paco-status">
    <div class="paco-status__card">

      <!-- State 1: Polling -->
      <div v-if="status === 'polling'" class="paco-status__state">
        <div class="paco-status__spinner">
          <svg viewBox="0 0 50 50" class="paco-status__spinner-svg">
            <circle cx="25" cy="25" r="20" fill="none" stroke-width="4" />
          </svg>
        </div>
        <h2 class="paco-status__title">กำลังตรวจสอบการชำระเงิน</h2>
        <p class="paco-status__subtitle">กรุณารอสักครู่ ระบบกำลังยืนยันการชำระเงินของคุณ</p>
        <div class="paco-status__progress">
          <div class="paco-status__progress-bar"></div>
        </div>
      </div>

      <!-- State 2: Confirmed -->
      <div v-if="status === 'confirmed'" class="paco-status__state">
        <div class="paco-status__icon paco-status__icon--success">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h2 class="paco-status__title paco-status__title--success">การบริจาคของคุณสำเร็จแล้ว</h2>
        <p class="paco-status__subtitle">{{ confirmationMessage }}</p>
        <p class="paco-status__note">ระบบจะส่งอีเมลยืนยันพร้อมรายละเอียดให้คุณเร็ว ๆ นี้</p>
        <div class="paco-status__redirect">
          <span class="paco-status__redirect-dot"></span>
          กำลังพาคุณไปยังหน้ายืนยัน...
        </div>
      </div>

      <!-- State 3: Timeout -->
      <div v-if="status === 'timeout'" class="paco-status__state">
        <div class="paco-status__icon paco-status__icon--warning">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 class="paco-status__title paco-status__title--warning">ไม่สามารถยืนยันการชำระเงินได้</h2>
        <p class="paco-status__subtitle">ไม่สามารถยืนยันการชำระเงินได้ในขณะนี้ กรุณาตรวจสอบอีเมลของคุณ หรือติดต่อเราเพื่อยืนยันสถานะการบริจาค</p>
        <a class="paco-status__btn" href="/">กลับไปยังหน้าหลัก</a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PacoStatus',
  data () {
    return {
      status: 'polling',
      orderId: '',
      polling: null,
      confirmationMessage: ''
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId
    this.preview = this.$route.query.preview === '1'
    if (this.preview) {
      this.status = this.$route.query.state || 'polling'
      return
    }
    if (!this.orderId) {
      this.status = 'timeout'
      return
    }
    this.startPolling()
  },
  beforeDestroy () {
    if (this.polling) {
      clearInterval(this.polling)
    }
  },
  methods: {
    startPolling () {
      const maxAttempts = 10
      let attempts = 0

      this.polling = setInterval(async () => {
        attempts++
        if (attempts > maxAttempts) {
          clearInterval(this.polling)
          this.status = 'timeout'
          return
        }

        try {
          const resp = await this.$http.get(`paco/status?orderId=${this.orderId}`)
          if (resp.body && resp.body.paid) {
            clearInterval(this.polling)
            this.status = 'confirmed'
            this.$store.dispatch('clearCart')

            const donateType = this.$store ? this.$store.state.donateType : 'monthly'
            if (donateType === 'daily') {
              this.confirmationMessage = 'การบริจาครายวันของคุณเริ่มต้นแล้ว ระบบจะหักเงินจากบัตรของคุณโดยอัตโนมัติทุกวัน'
            } else {
              this.confirmationMessage = 'การบริจาครายเดือนของคุณเริ่มต้นแล้ว ระบบจะหักเงินจากบัตรของคุณโดยอัตโนมัติทุกเดือน'
            }

            const thankYouId = resp.body.publicOrderId || this.orderId
            setTimeout(() => {
              this.$router.push('/thank-you/' + thankYouId)
            }, 3000)
          }
        } catch (e) {
          // Continue polling on error
        }
      }, 3000)
    }
  }
}
</script>

<style scoped>
.paco-status {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  background: #CCE9EE;
}

.paco-status__card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 20px rgba(21, 48, 80, 0.08);
  max-width: 480px;
  width: 100%;
  padding: 3rem 2.5rem;
  text-align: center;
}

.paco-status__state {
  animation: fadeInUp 0.4s ease-out;
}

/* Spinner */
.paco-status__spinner {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
}

.paco-status__spinner-svg {
  animation: spin 1.2s linear infinite;
  width: 100%;
  height: 100%;
}

.paco-status__spinner-svg circle {
  stroke: #38AB49;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

/* Progress bar */
.paco-status__progress {
  margin-top: 2rem;
  height: 3px;
  background: #e8e8e8;
  border-radius: 3px;
  overflow: hidden;
}

.paco-status__progress-bar {
  height: 100%;
  background: #38AB49;
  border-radius: 3px;
  animation: progress 30s linear;
  width: 0%;
}

/* Icons */
.paco-status__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  animation: scaleIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.paco-status__icon svg {
  width: 32px;
  height: 32px;
}

.paco-status__icon--success {
  background: #e8f5e9;
  color: #38AB49;
}

.paco-status__icon--warning {
  background: #fff3e0;
  color: #e65100;
}

/* Typography */
.paco-status__title {
  font-family: 'Wittaya-Medium', Thonburi, Arial, sans-serif;
  font-size: 1.5rem;
  color: #153050;
  margin: 0 0 0.75rem;
  line-height: 1.4;
}

.paco-status__title--success {
  color: #2e7d32;
}

.paco-status__title--warning {
  color: #e65100;
}

.paco-status__subtitle {
  font-family: 'Wittaya-Light', Arial, sans-serif;
  font-size: 1.05rem;
  color: #546e7a;
  margin: 0 0 0.5rem;
  line-height: 1.6;
}

.paco-status__note {
  font-family: 'Wittaya-Light', Arial, sans-serif;
  font-size: 0.9rem;
  color: #90a4ae;
  margin: 0.5rem 0 0;
}

/* Redirect indicator */
.paco-status__redirect {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e8e8e8;
  font-family: 'Wittaya-Light', Arial, sans-serif;
  font-size: 0.9rem;
  color: #90a4ae;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.paco-status__redirect-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #38AB49;
  animation: pulse 1s ease-in-out infinite;
}

/* Button */
.paco-status__btn {
  display: inline-block;
  margin-top: 1.5rem;
  padding: 0.75rem 2rem;
  background: #1E416D;
  color: #fff;
  border-radius: 8px;
  font-family: 'Wittaya-Medium', Thonburi, Arial, sans-serif;
  font-size: 1rem;
  text-decoration: none;
  transition: background 0.2s;
}

.paco-status__btn:hover {
  background: #153050;
  color: #fff;
  text-decoration: none;
}

/* Animations */
@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes dash {
  0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
  50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
  100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; }
}

@keyframes progress {
  from { width: 0%; }
  to { width: 95%; }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.5); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

@media (max-width: 480px) {
  .paco-status__card {
    padding: 2rem 1.5rem;
  }
  .paco-status__title {
    font-size: 1.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// PacoStatus.vue?c001ae8a